/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientUser } from '../models/ClientUser';
import type { TransportCardInfo } from '../models/TransportCardInfo';
import type { UserSettingsSavePostRequest } from '../models/UserSettingsSavePostRequest';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async changeContacts(
        requestBody: UserSettingsSavePostRequest,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/user/changeContacts`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns TransportCardInfo Ok
     * @throws ApiError
     */
    public static async getUserTransport(): Promise<TransportCardInfo> {
        const result = await __request({
            method: 'POST',
            path: `/user/transport`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns any Ok
     * @throws ApiError
     */
    public static async getUserQr(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/user/qr`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns ClientUser Ok
     * @throws ApiError
     */
    public static async getUser(): Promise<ClientUser> {
        const result = await __request({
            method: 'GET',
            path: `/user`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}